// Namespacing

window.site = (window.site || {});

// Side panel - opened / close

site.NewsletterForm = (function NewsletterForm ($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false,
    newsletterForm = $('#newsletter-form');

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Initiate SidePanel
    // submitForm();

    return true;

  };

  // ------------------------------------
  // INIT
  // ------------------------------------

  var submitForm = function() {
    window.ParsleyValidator.setLocale($('html').attr('lang'));
    $('#newsletter-form').parsley().on('form:submit', function() {

      $.post('actions/mailchimpSubscribe/list/Subscribe', newsletterForm.serialize())
        .done(function (data) {

          if (!data.success) {
            // there was an error, do something with data
            alert(data.message);
          }
          else {
            // Success
            newsletterForm[0].reset();
            swal(
              CONTACT_SUCCESS_TITLE,
              NEWSLETTER_SUCCESS_MESSAGE,
              'success'
            );
          }
        });
      return false;
    });
  };

  return {
    init: init
  };

}.bind(site, jQuery)());